import PropTypes from 'prop-types';
import React from 'react';
import {
  Alert,
  Button,
  Image,
} from 'react-bootstrap';
import EventIcon from './EventIcon';
import PlaceDetail from './PlaceDetail';
import { EVENT_NAMES } from './EventStyles';
import { formalDate } from '../../../core/date';


const EventDate = (event) => {
  if (event.event_type === 'stay' || event.event_type === 'nost') {
    return `${formalDate(event.start)} - ${formalDate(event.end)}`;
  }
  return formalDate(event.start);
};

function formatRelatedEvent(event, events) {
  const name = event.group_name;
  let location = `${event.place.city} ${event.place.state}`;
  let hotel = 'No hotel booked!!!';

  if (event.event_type === 'nost') {
    hotel = 'No hotel needed.';
  }
  if (event.bids.hotel) {
    hotel = event.bids.hotel.name;
    location = `${event.bids.hotel.city}, ${event.bids.hotel.state}`;
  }
  events.push((
    <div className="col-sm-6">
      <p><strong>{name}</strong></p>
      <p>{hotel}</p>
      <p>{location}</p>
      <p>{ EventDate(event) }</p>
    </div>
  ));
}

class EventDetail extends React.Component {
  render() {
    const { event } = this.props;
    const alerts = [];
    const showVenueMisMatchAlert = (
      <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
        <h4>Venue information missing!</h4>
        <p>
        This show is connected to city location instead of venue.
        Your hotel search will be centered the city center instead of the venue.
        This often happens on imports when the venue is misspelled or missing from our database.
        </p>
        <p>
          <Button onClick={this.handleAlertDismiss}>Hide Alert</Button>
        </p>
      </Alert>
    );
    if (event.event_type === 'show' && event.place.place_type !== 'VENUE') {
      alerts.push(showVenueMisMatchAlert);
    }
    const related = [];
    if (event.event_type === 'stay') {
      const relatedEvents = event.related_group_events;
      for (let i = 0, len = relatedEvents.length; i < len; i++) {
        formatRelatedEvent(relatedEvents[i], related);
      }
    }
    const name = event.name ? event.name : EVENT_NAMES[event.event_type];


    return (
      <div className="container">
        { alerts.length !== 0 && (
          <div className="row"><div className="col-md-8">{alerts}</div></div>)
        }
        <div className="row">
          <div className="col-md-4">
            <h4><EventIcon eventType={event.event_type} />{name}</h4>
            <p>{ EventDate(event) }</p>
            { event.place.image && (<Image src={event.place.image} responsive />) }
          </div>
          <div className="col-md-4">
            <h4>Location</h4>
            <PlaceDetail place={event.place} />
          </div>
        </div>
        <div className="row">
          {related}
        </div>
        <div className="row">
          <div className="col-md-8">
            <h4>Notes</h4>
            <div className="panel panel-default">
              {event.notes}
            </div>
          </div>
        </div>
      </div>
    );
  }
}


EventDetail.propTypes = {
  event: PropTypes.object.isRequired,
  // sendProposal: PropTypes.func.isRequired,
};

export default EventDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/EventDetail.js